import { DynamicForm, FormConfig } from "@components/DynamicForm/DynamicForm";
import { useNotification } from "@hooks/useNotification";
import { useQuery } from "@hooks/useQuery";
import { useDocumentDetails } from "@modules/ECMS/MAGP/ApprovalManagement/Drilldown.Hooks";
import { decodeHTML } from "@utils/CommonUtils";
import { useEffect } from "react";
import { FieldValues } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { useAuth } from "~/Hooks/useAuth";
import { post, put } from "~/Services";
import { eramanHost } from "~/Utils";
import { useEpcMembership } from "../Contents.hook";
import { fields } from "../constants";

export const EpcMembership = () => {
  const query = useQuery();
  const navigate = useNavigate();
  const { openToast } = useNotification();
  const { user } = useAuth();

  const { data: editData, error, isLoading: drilldownLoading, isError, refetch: refetchEditData } = useEpcMembership();

  const {
    data: dataById,
    isLoading: isLoadingData,
    refetch: refetchDocument,
  } = useDocumentDetails(query?.get("id") || "");

  useEffect(() => {
    if (query.get("id")) {
      refetchDocument();
    } else {
      refetchEditData();
    }
  }, [query.get("id")]);

  const AwardsFormConfig: FormConfig = {
    initialValues: {
      field_country_text: decodeHTML(
        dataById ? dataById.payload.field_country_text : editData ? editData?.[0]?.field_country_text : ""
      ),
      field_country_text_ms: decodeHTML(
        dataById ? dataById.payload.field_country_text_ms : editData ? editData?.[0].field_country_text_ms : ""
      ),
      field_country_text_zh: decodeHTML(
        dataById ? dataById.payload.field_country_text_zh : editData ? editData?.[0]?.field_country_text_zh : ""
      ),
      title: decodeHTML(dataById ? dataById.payload.title : editData ? editData?.[0]?.title : ""),

      body: decodeHTML(dataById ? dataById.payload.body : editData ? editData?.[0]?.body : ""),
      field_epc_description_ms: decodeHTML(
        dataById ? dataById.payload.field_epc_description_ms : editData ? editData?.[0]?.field_epc_description_ms : ""
      ),
      field_epc_description_zh: decodeHTML(
        dataById ? dataById.payload.field_epc_description_zh : editData ? editData?.[0]?.field_epc_description_zh : ""
      ),

      field_epc_member_description: decodeHTML(
        dataById
          ? dataById.payload.field_epc_member_description
          : editData
            ? editData?.[0]?.field_epc_member_description
            : ""
      ),
      field_epc_member_description_ms: decodeHTML(
        dataById
          ? dataById.payload.field_epc_member_description_ms
          : editData
            ? editData?.[0]?.field_epc_member_description_ms
            : ""
      ),
      field_epc_member_description_zh: decodeHTML(
        dataById
          ? dataById.payload.field_epc_member_description_zh
          : editData
            ? editData?.[0]?.field_epc_member_description_zh
            : ""
      ),

      field_date_of_birth_text: decodeHTML(
        dataById ? dataById.payload.field_date_of_birth_text : editData ? editData?.[0]?.field_date_of_birth_text : ""
      ),
      field_date_of_birth_text_ms: decodeHTML(
        dataById
          ? dataById.payload.field_date_of_birth_text_ms
          : editData
            ? editData?.[0]?.field_date_of_birth_text_ms
            : ""
      ),
      field_date_of_birth_text_zh: decodeHTML(
        dataById
          ? dataById.payload.field_date_of_birth_text_zh
          : editData
            ? editData?.[0]?.field_date_of_birth_text_zh
            : ""
      ),

      field_edit_epc_details_ms: decodeHTML(
        dataById ? dataById.payload.field_edit_epc_details_ms : editData ? editData?.[0]?.field_edit_epc_details_ms : ""
      ),
      field_edit_epc_details_text: decodeHTML(
        dataById
          ? dataById.payload.field_edit_epc_details_text
          : editData
            ? editData?.[0]?.field_edit_epc_details_text
            : ""
      ),
      field_edit_epc_details_zh: decodeHTML(
        dataById ? dataById.payload.field_edit_epc_details_zh : editData ? editData?.[0]?.field_edit_epc_details_zh : ""
      ),

      field_email: decodeHTML(dataById ? dataById.payload.field_email : editData ? editData?.[0]?.field_email : ""),
      field_email_text_ms: decodeHTML(
        dataById ? dataById.payload.field_email_text_ms : editData ? editData?.[0]?.field_email_text_ms : ""
      ),
      field_email_text_zh: decodeHTML(
        dataById ? dataById.payload.field_email_text_zh : editData ? editData?.[0]?.field_email_text_zh : ""
      ),

      field_epc_id: decodeHTML(dataById ? dataById.payload.field_epc_id : editData ? editData?.[0]?.field_epc_id : ""),
      field_epc_id_text_ms: decodeHTML(
        dataById ? dataById.payload.field_epc_id_text_ms : editData ? editData?.[0]?.field_epc_id_text_ms : ""
      ),
      field_epc_id_text_zh: decodeHTML(
        dataById ? dataById.payload.field_epc_id_text_zh : editData ? editData?.[0]?.field_epc_id_text_zh : ""
      ),

      field_epc_card_heading_en: decodeHTML(
        dataById ? dataById.payload.field_epc_card_heading_en : editData ? editData?.[0]?.field_epc_card_heading_en : ""
      ),
      field_epc_card_heading_ms: decodeHTML(
        dataById ? dataById.payload.field_epc_card_heading_ms : editData ? editData?.[0]?.field_epc_card_heading_ms : ""
      ),
      field_epc_card_heading_zh: decodeHTML(
        dataById ? dataById.payload.field_epc_card_heading_zh : editData ? editData?.[0]?.field_epc_card_heading_zh : ""
      ),

      field_epc_type: decodeHTML(
        dataById ? dataById.payload.field_epc_type : editData ? editData?.[0]?.field_epc_type : ""
      ),
      field_epc_type_ms: decodeHTML(
        dataById ? dataById.payload.field_epc_type_ms : editData ? editData?.[0]?.field_epc_type_ms : ""
      ),
      field_epc_type_zh: decodeHTML(
        dataById ? dataById.payload.field_epc_type_zh : editData ? editData?.[0]?.field_epc_type_zh : ""
      ),

      field_expiry_date_text: decodeHTML(
        dataById ? dataById.payload.field_expiry_date_text : editData ? editData?.[0]?.field_expiry_date_text : ""
      ),
      field_expiry_date_text_ms: decodeHTML(
        dataById ? dataById.payload.field_expiry_date_text_ms : editData ? editData?.[0]?.field_expiry_date_text_ms : ""
      ),
      field_expiry_date_text_zh: decodeHTML(
        dataById ? dataById.payload.field_expiry_date_text_zh : editData ? editData?.[0]?.field_expiry_date_text_zh : ""
      ),

      field_full_name: decodeHTML(
        dataById ? dataById.payload.field_full_name : editData ? editData?.[0]?.field_full_name : ""
      ),
      field_full_name_ms: decodeHTML(
        dataById ? dataById.payload.field_full_name_ms : editData ? editData?.[0]?.field_full_name_ms : ""
      ),
      field_full_name_zh: decodeHTML(
        dataById ? dataById.payload.field_full_name_zh : editData ? editData?.[0]?.field_full_name_zh : ""
      ),

      field_gender_text: decodeHTML(
        dataById ? dataById.payload.field_gender_text : editData ? editData?.[0]?.field_gender_text : ""
      ),
      field_gender_text_ms: decodeHTML(
        dataById ? dataById.payload.field_gender_text_ms : editData ? editData?.[0]?.field_gender_text_ms : ""
      ),
      field_gender_text_zh: decodeHTML(
        dataById ? dataById.payload.field_gender_text_zh : editData ? editData?.[0]?.field_gender_text_zh : ""
      ),

      field_key: decodeHTML(dataById ? dataById.payload.field_key : editData ? editData?.[0]?.field_key : ""),

      field_mobile_number: decodeHTML(
        dataById ? dataById.payload.field_mobile_number : editData ? editData?.[0]?.field_mobile_number : ""
      ),
      field_mobile_number_text_ms: decodeHTML(
        dataById
          ? dataById.payload.field_mobile_number_text_ms
          : editData
            ? editData?.[0]?.field_mobile_number_text_ms
            : ""
      ),
      field_mobile_number_text_zh: decodeHTML(
        dataById
          ? dataById.payload.field_mobile_number_text_zh
          : editData
            ? editData?.[0]?.field_mobile_number_text_zh
            : ""
      ),

      field_nationality: decodeHTML(
        dataById ? dataById.payload.field_nationality : editData ? editData?.[0]?.field_nationality : ""
      ),
      field_nationality_text_ms: decodeHTML(
        dataById ? dataById.payload.field_nationality_text_ms : editData ? editData?.[0]?.field_nationality_text_ms : ""
      ),
      field_nationality_text_zh: decodeHTML(
        dataById ? dataById.payload.field_nationality_text_zh : editData ? editData?.[0]?.field_nationality_text_zh : ""
      ),

      field_nric_text: decodeHTML(
        dataById ? dataById.payload.field_nric_text : editData ? editData?.[0]?.field_nric_text : ""
      ),
      field_nric_text_ms: decodeHTML(
        dataById ? dataById.payload.field_nric_text_ms : editData ? editData?.[0]?.field_nric_text_ms : ""
      ),
      field_nric_text_zh: decodeHTML(
        dataById ? dataById.payload.field_nric_text_zh : editData ? editData?.[0]?.field_nric_text_zh : ""
      ),

      field_passport_text: decodeHTML(
        dataById ? dataById.payload.field_passport_text : editData ? editData?.[0]?.field_passport_text : ""
      ),
      field_password_text_ms: decodeHTML(
        dataById ? dataById.payload.field_password_text_ms : editData ? editData?.[0]?.field_password_text_ms : ""
      ),
      field_passport_number_text_zh: decodeHTML(
        dataById
          ? dataById.payload.field_passport_number_text_zh
          : editData
            ? editData?.[0]?.field_passport_number_text_zh
            : ""
      ),

      field_promotion_material: decodeHTML(
        dataById ? dataById.payload.field_promotion_material : editData ? editData?.[0]?.field_promotion_material : ""
      ),
      field_promotion_material_ms: decodeHTML(
        dataById
          ? dataById.payload.field_promotion_material_ms
          : editData
            ? editData?.[0]?.field_promotion_material_ms
            : ""
      ),
      field_promotion_material_zh: decodeHTML(
        dataById
          ? dataById.payload.field_promotion_material_zh
          : editData
            ? editData?.[0]?.field_promotion_material_zh
            : ""
      ),

      field_state_text: decodeHTML(
        dataById ? dataById.payload.field_state_text : editData ? editData?.[0]?.field_state_text : ""
      ),
      field_state_text_ms: decodeHTML(
        dataById ? dataById.payload.field_state_text_ms : editData ? editData?.[0]?.field_state_text_ms : ""
      ),
      field_state_text_zh: decodeHTML(
        dataById ? dataById.payload.field_state_text_zh : editData ? editData?.[0]?.field_state_text_zh : ""
      ),

      title_text_En: decodeHTML(
        dataById ? dataById.payload.title_text_En : editData ? editData?.[0]?.title_text_En : ""
      ),
      field_title_text_ms: decodeHTML(
        dataById ? dataById.payload.field_title_text_ms : editData ? editData?.[0]?.field_title_text_ms : ""
      ),
      field_title_text_zh: decodeHTML(
        dataById ? dataById.payload.field_title_text_zh : editData ? editData?.[0]?.field_title_text_zh : ""
      ),

      field_upgrade_text: decodeHTML(
        dataById ? dataById.payload.field_upgrade_text : editData ? editData?.[0]?.field_upgrade_text : ""
      ),
      field_upgrade_text_ms: decodeHTML(
        dataById ? dataById.payload.field_upgrade_text_ms : editData ? editData?.[0]?.field_upgrade_text_ms : ""
      ),
      field_upgrade_text_zh: decodeHTML(
        dataById ? dataById.payload.field_upgrade_text_zh : editData ? editData?.[0]?.field_upgrade_text_zh : ""
      ),

      priorityCard: dataById?.payload
        ? decodeHTML([
            {
              uid: "-1",
              name: "priorityCard.png",
              status: "done",
              url: dataById?.payload?.priorityCard,
            },
          ])
        : decodeHTML([
            {
              uid: "-1",
              name: "priorityCard.png",
              status: "done",
              url: editData?.[0]?.priorityCard,
            },
          ]),
      preferredCard: dataById?.payload
        ? decodeHTML([
            {
              uid: "-1",
              name: "preferredCard.png",
              status: "done",
              url: dataById?.payload?.preferredCard,
            },
          ])
        : decodeHTML([
            {
              uid: "-1",
              name: "preferredCard.png",
              status: "done",
              url: editData?.[0]?.preferredCard,
            },
          ]),
      classicCard: dataById?.payload
        ? decodeHTML([
            {
              uid: "-1",
              name: "classicCard.png",
              status: "done",
              url: dataById?.payload?.classicCard,
            },
          ])
        : decodeHTML([
            {
              uid: "-1",
              name: "classicCard.png",
              status: "done",
              url: editData?.[0]?.classicCard,
            },
          ]),
    },
    fields: fields.epcMembership,
  };

  const onSubmit = async (
    data: FieldValues,
    apiUrl: string,
    action: string,
    method: string,
    status: "DRAFT" | "PENDING",
    reviewNotes?: string
  ) => {
    let imageKeys: any = [
      "field_epc_card3",
      "field_epc_card2",
      "field_epc_card1",
      "priorityCard",
      "preferredCard",
      "classicCard",
    ];
    for (const key of imageKeys) {
      try {
        let field = data[key];
        if (field?.[0]?.originFileObj) {
          const formData = new FormData();
          formData.append("upload-file", field[0].originFileObj);
          formData.append("application", "ERAMAN");
          const res: any = await post("management/upload-file", formData);

          if (res) {
            data[key] = res.response.data;
          }
        } else if (field?.[0]?.url) {
          data[key] = field[0].url;
        } else {
          data[key] = ""; // fallback in case of invalid field
        }
      } catch (error) {
        console.error("Image processing failed for:", key, error);
      }
    }

    // let descKeys: any = [
    //   "field_epc_member_description_zh",
    //   "field_epc_member_description_ms",
    //   "field_epc_member_description",
    //   "field_epc_description_zh",
    //   "field_epc_description_ms",
    //   "body",
    // ];
    // for (const key of descKeys) {
    //   try {
    //     data[key] = {
    //       value: data[key] || "",
    //       format: "full_html",
    //     };
    //   } catch (error) { }
    // }

    const payload = {
      action: action,
      method: method,
      module: "Contents",
      subModule: `epcMembership`,
      type: "DEDICATED",
      application: "ERAMAN",
      reviewNotes: reviewNotes,
      appList: [
        {
          appName: "ERAMAN",
          apiUrl: apiUrl,
        },
      ],
      payload: {
        ...(action === "UPDATE" && { id: editData?.[0]?.nid || dataById?.payload?.nid }),
        ...data,
        published: true,
      },
      status: status,
    };
    if (query.get("id")) {
      put(`/management/update-document?approvalId=${query.get("id")}`, payload)
        .then((response: any) => {
          openToast({
            content: status == "PENDING" ? "Data Sent for Review" : "Data Saved Successfully",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    } else {
      post("/management/publish", payload)
        .then((response: any) => {
          openToast({
            content: status == "DRAFT" ? "Data saved successfully" : "Data Sent for Review",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
          // refetchDocument();
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    }
  };

  return (
    <>
      <DynamicForm
        isLoading={isLoadingData || drilldownLoading}
        config={AwardsFormConfig}
        onSubmit={(data, buttonValue, reviewNotes) =>
          onSubmit(
            data,
            `${eramanHost}/api/epcdetailsandcard/${editData?.[0]?.nid || dataById?.payload?.nid}`,
            "UPDATE",
            "PATCH",
            buttonValue == "save" ? "DRAFT" : "PENDING",
            reviewNotes
          )
        }
      />
    </>
  );
};
